import { notify, Page } from "@general-backoffice/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { Navigate, useSearchParams } from "react-router-dom";

import { resetPassword } from "../../../api";
import getErrorMessage from "../../../utils/getErrorMessage";

// Local type definitions
interface ResetPasswordCredentials {
  password: string;
  passwordConfirm: string;
}

const ResetPassword: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("auth", { keyPrefix: "resetPassword" });
  const [searchParams] = useSearchParams();

  const token = searchParams.get("code");

  const onSubmit = async ({ password, passwordConfirm }: ResetPasswordCredentials) =>
    resetPassword(token || "", password, passwordConfirm)
      .then(() => {
        notify.success(t("successMessage"));
        navigate("/auth/login");
      })
      .catch((err: unknown) => {
        notify.error(getErrorMessage(err, "Error"));
      });

  if (!token) return <Navigate to="/" replace />;
  return (
    <Page.ResetPassword
      title={t("title")}
      lead={t("lead")}
      minLengthPassword={8}
      passwordPlaceholder={t("passwordPlaceholder")}
      passwordConfirmPlaceholder={t("passwordConfirmPlaceholder")}
      invalidPasswordFeedbackText={t("invalidPasswordFeedbackText")}
      invalidPasswordConfirmFeedbackText={t("invalidPasswordConfirmFeedbackText")}
      submitText={t("submitText")}
      onSubmit={onSubmit}
    />
  );
};

export default ResetPassword;
